<!-- 快应用推广链接 -->
<template>
<div>
	<div id="put-account" :style="{'width':table_scroll_width + 'px',}">
	<div :style="{'width':body_width - 60 + 'px',}" style="position: sticky;left: 30px;z-index: 5;">
		<a-tabs :activeKey="tab_key" type="card" @change="callback" :tabBarGutter="10">
			<a-tab-pane v-for="(item,index) in showTabData" :key="item.keys" :tab="item.name"></a-tab-pane>
			<!-- <a-tab-pane key="1" tab="文鼎推广链接"></a-tab-pane>
			<a-tab-pane key="2" tab="常读推广链接"></a-tab-pane>
			<a-tab-pane key="3" tab="点众渠道"></a-tab-pane> -->
		</a-tabs>
	</div>
	</div>	
		
	<div style="padding: 0 0 30px 0;">
		<router-view/>
	</div>
</div>
</template>

<script>
export default {
	name: 'putLinkIndex_',
	components: {
		
	},
	data() {
		return {
			tab_key: "1",
			body_width: 1600,
			table_scroll_width: 1600,
			
			tabData: [
				{name:"文鼎推广链接", keys: "1", urls:"/putLinkWd", },
				{name:"常读推广链接", keys: "2", urls:"/putLinkCd", },
				{name:"点众渠道", keys: "3", urls:"/putLinkDz", },
				{name:"乐读推广链接", keys: "5", urls:"/putLinkLd", },
				{name:"小程序推广链接", keys: "6", urls:"/putlinkXcx", },
			],
			showTabData: [{name:"",}],
		}
	},
	mounted(){
		let that = this
		function checkTab(urls){ // 为了避免多个菜单设置了同样的tab路径，所以这里要重新执行一边控制显示哪些tab的代码
		
		// console.log("路由地址",this.$route.fullPath);
		let page_path = that.$route.fullPath
		let tab_path = []
		
		let n_data = JSON.parse(localStorage.getItem("get_navData"))
		// 找出当前路径所在的vues数据。
		n_data.forEach((res,index)=>{
			if(res.child.length != 0){
				res.child.forEach((res_a,index_a)=>{
					if(res_a.child.length != 0){
						res_a.child.forEach((res_c,index_c)=>{
							
							res_c.vues.forEach((res_e,index_e)=>{
								if(res_e.vue_url == page_path){
									tab_path = res_c.vues
								}
							})
							
						})
					}
				})
				
			}
		})
		
		let tt_data = []
		// 根据后端配置的顺序进行排序
		tab_path.forEach((res,index)=>{
			that.tabData.forEach((res_z,index_z)=>{
				if(res.vue_url == res_z.urls){
					tt_data.push(res_z)
				}
			})
		})
		that.showTabData = tt_data
		console.log("showTabData",tt_data);
		
		
			if(urls.indexOf("putLinkWd") > -1){ // 文鼎推广链接
				that.tab_key = "1"
			}
			else if(urls.indexOf("putLinkCd") > -1){ // 常读推广链接
				that.tab_key = "2"
			}
			else if(urls.indexOf("putLinkDz") > -1){ // 点众渠道
				that.tab_key = "3"
			}
			else if(urls.indexOf("putLinkLd") > -1){ // 乐读推广链接
				that.tab_key = "5"
			}
			else if(urls.indexOf("putlinkXcx") > -1){ // 乐读推广链接
				that.tab_key = "6"
			}
		}
		// 保证页面刷新能更新tab选中状态
		checkTab(this.$route.fullPath)
		
		that.body_width = document.body.clientWidth // 筛选条件大盒子的宽度
		// 接收粘性定位用的参数
		this.$bus.$on('stickyData',(e)=>{
		    console.log('orderIndex',e)
			that.table_scroll_width = e
		})
		
		// 接收子页面传过来的路径
		this.$bus.$on('tabPath',(e)=>{
		    console.log('putLink-tabPath-----',e)
			// that.table_scroll_width = e
			checkTab(e)
		})
		
	},
	// 销毁生命周期
	beforeDestroy(){
	    this.$bus.$off('stickyData') // 销毁，减轻vue压力
		// 如果不销毁，后面可能会重复执行多次，因为没有销毁，所以触发的会一直在
		this.$bus.$off('tabPath') // 销毁，减轻vue压力
	},
	methods:{
		// 切换tab
		callback(e){
			console.log(e);
			if(e == "1"){ // 文鼎推广链接
				this.tab_key = "1"
				this.$router.push({path: '/putLinkWd'})
			}
			else if(e == "2"){ // 常读推广链接
				this.tab_key = "2"
				this.$router.push({path: '/putLinkCd'})
			}
			else if(e == "3"){ // 点众渠道
				this.tab_key = "3"
				this.$router.push({path: '/putLinkDz'})
			}
			else if(e == "5"){ // 乐读推广链接
				this.tab_key = "5"
				this.$router.push({path: '/putLinkLd'})
			}
			else if(e == "6"){ // 视频小程序推广链接
				this.tab_key = "6"
				this.$router.push({path: '/putlinkXcx'})
			}
		}
	}
}
</script>

<style>

</style>